import { z } from 'zod'

export const votingPhaseEnum = z.enum(['NOMINATING', 'RANKING', 'REVEAL'])

export const advanceVotingPhaseSchema = z.object({
  phase: votingPhaseEnum,
})

export const createNominationSchema = z.object({
  bookId: z.string().min(1, 'Book is required'),
})

const rankingItemSchema = z.object({
  bookId: z.string().min(1, 'Book ID is required'),
  rank: z.number().int().positive('Rank must be a positive integer'),
})

export const submitRankingsSchema = z.object({
  rankings: z
    .array(rankingItemSchema)
    .min(2, 'You must rank at least 2 books')
    .refine(
      (rankings) => {
        const ranks = rankings.map((r) => r.rank)
        return new Set(ranks).size === ranks.length
      },
      { message: 'Each rank must be unique' }
    )
    .refine(
      (rankings) => {
        const bookIds = rankings.map((r) => r.bookId)
        return new Set(bookIds).size === bookIds.length
      },
      { message: 'Each book can only be ranked once' }
    ),
})

export type AdvanceVotingPhaseInput = z.infer<typeof advanceVotingPhaseSchema>
export type CreateNominationInput = z.infer<typeof createNominationSchema>
export type SubmitRankingsInput = z.infer<typeof submitRankingsSchema>
